var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoWcon05 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_wcon_05_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_wcon_05_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h60v60H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M0 0h60v60H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M44.345 16.792h-3.78l-5.111 11.176L30 16.043l-5.451 11.925-5.114-11.176h-3.78l8.868 19.405L30 24.215l5.477 11.982z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  clipPath: "url(#logo_wcon_05_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M47.477 41.073h-4.035v.799h1.538v4.205h.959v-4.205h1.538zM27.26 44.403l-2.653-3.33h-.742v5.004h.938v-3.334l2.656 3.334h.738v-5.004h-.937zM35.538 45.278v-1.304h2.328v-.798h-2.328v-1.304h2.654v-.799h-3.613v5.004h3.656v-.8zM20.383 40.94c-1.572 0-2.661 1.14-2.663 2.635.002 1.494 1.091 2.635 2.663 2.635s2.655-1.141 2.657-2.635c-.002-1.494-1.046-2.636-2.657-2.636m0 4.38c-.959 0-1.655-.733-1.66-1.745.005-1.012.702-1.746 1.66-1.746s1.649.717 1.654 1.746c-.005 1.028-.683 1.745-1.654 1.745M15.3 46.21c1.03 0 1.7-.478 2.117-1.15l-.704-.527c-.264.466-.737.788-1.414.788-.96 0-1.655-.734-1.66-1.746.005-1.012.701-1.746 1.66-1.746.62 0 1.025.244 1.282.567l.653-.647c-.435-.511-1.07-.81-1.935-.81-1.573 0-2.662 1.142-2.663 2.636.001 1.494 1.09 2.635 2.663 2.635M31.687 46.21c1.031 0 1.701-.478 2.117-1.15l-.703-.527c-.264.466-.737.788-1.415.788-.959 0-1.655-.734-1.66-1.746.005-1.012.702-1.746 1.66-1.746.621 0 1.025.244 1.283.567l.652-.647c-.434-.511-1.069-.81-1.935-.81-1.572 0-2.661 1.142-2.663 2.636.002 1.494 1.091 2.635 2.663 2.635M41.259 41.073h-2.044v5.003h.96v-1.703h.986c1.07 0 1.945-.58 1.945-1.65s-.715-1.65-1.848-1.65m-.11 2.502h-.975v-1.703h.974c.622 0 1.02.29 1.02.852 0 .507-.39.851-1.02.851"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_wcon_05_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 60,
  fill: "#fff",
  rx: 30
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_wcon_05_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h60v60H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_wcon_05_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.516 40.873h34.968v5.404H12.516z"
})))));
export default SvgLogoWcon05;